export default "__VITE_ASSET__3062c9f2__"